function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.5 7H10M7.5 8.3h2.1M7.5 9.6H11m-3.5 1.3h2.2m-2.2 1.3H11m2.7 2.6H7c-.3 0-.6-.1-.9-.4s-.4-.6-.4-.9V5.2h6.9v8.5c0 .5.3.8.6 1 .4.2.8.2 1.1 0s.5-.5.5-.9v-2.6h-2.1",
  fill: "none",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeWidth: ".5",
  stroke: "currentColor"
}));